<template>
  <div class="s-reviews" :class="`s-reviews--${layout}`">
    <template
      v-for="(review, index) in props.reviews"
      :key="review.id ?? `review-${index}`"
    >
      <SReview :editable :loading :review="review" @edit-review="editReview" />
      <PDivider
        v-if="layout === 'list' && index < props.reviews.length - 1"
        class="s-reviews__divider"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import PDivider from "@/atoms/PDivider.vue";

import SReview from "./SReview.vue";

const props = withDefaults(
  defineProps<{
    editable?: boolean;
    layout?: "grid" | "list";
    loading?: boolean;
    reviews: App.DTO.Customer.Review.CustomerReviewDTO[];
  }>(),
  {
    editable: false,
    layout: "list",
    loading: false,
  },
);

const emit =
  defineEmits<(event: "editReview", customerId: number | null) => void>();

function editReview(reviewId: number | null) {
  emit("editReview", reviewId);
}
</script>

<style lang="postcss">
@import "./reviews.css";
</style>
